module.exports = __webpack_public_path__ + "img/2019051624btn_3_03.64d8860c.png";